import { useCallback } from 'react';

import { Container, LeftSection, RightSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';
import { SecondaryPageLayoutLoading } from '@/_containers/layout/secondary-page-layout';
import AssociatedCompaniesLoading from '@/_pages/competitors/associated-companies/loading';
import ContactsLoading from '@/_pages/competitors/contacts/loading';
import ProfileLoading from '@/_pages/competitors/profile/loading';
import { ProfileRightSectionLoading } from '@/_pages/competitors/profile/right-section';
import { HeaderLoading } from '@/_pages/competitors/shared/components/header-section';
import { competitorsSubNav, useCurrentLocation } from '@/_shared';

export function TemplateLoading() {
  const { matched } = useCurrentLocation();
  const { tabKey, renderRightColumn } = matched?.staticData ?? {};

  const render = useCallback(() => {
    switch (tabKey) {
      case 'competitor/associated-companies':
        return <AssociatedCompaniesLoading />;
      case 'competitor/contacts':
        return <ContactsLoading />;
      case 'competitor/profile':
      case 'competitor/notes':
      default:
        return <ProfileLoading />;
    }
  }, [tabKey]);

  return (
    <SecondaryPageLayoutLoading subNavLinks={competitorsSubNav}>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} allowBack />
      <Container>
        <LeftSection>
          <HeaderLoading />

          {render()}
        </LeftSection>
        {renderRightColumn && (
          <RightSection>
            <ProfileRightSectionLoading />
          </RightSection>
        )}
      </Container>
    </SecondaryPageLayoutLoading>
  );
}
